import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { FeatureFlagService } from './util-feature-flag-service/feature-flag.abstract.service';
import { FeatureFlagsBrowserService } from './util-feature-flag-service/feature-flag.browser.service';
import { FeatureFlagUserIdentificationService } from './util-feature-flag-user-identification-service/feature-user-identifier.service';

function initialiseLaunchDarkly(launchDarklyService: FeatureFlagService): () => Promise<void> {
  return () => launchDarklyService.load();
}

function initialiseUserIdentification(featureUserService: FeatureFlagUserIdentificationService) {
  return () => featureUserService.initialise();
}

export function provideRmaFeatureFlagsBrowser(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: FeatureFlagService,
      useClass: FeatureFlagsBrowserService,
    },

    provideAppInitializer(() => {
      const initializerFn = initialiseLaunchDarkly(inject(FeatureFlagService));
      return initializerFn();
    }),

    provideAppInitializer(() => {
      const initializerFn = initialiseUserIdentification(inject(FeatureFlagUserIdentificationService));
      return initializerFn();
    }),
  ]);
}
